module.exports = __webpack_public_path__ + "3427257dcbb78703cb3b26e4c5c8fb16.mp4";